<template>
  <div>
    <portal target-el="#filter">
      <div class="sub-header">
        <div class="header-item">
          <Breadcrumb separator-class="el-icon-arrow-right">
            <breadcrumb-item>
              <span @click="routeToIndentList">
                {{indentDetails && indentDetails.order_no}}
              </span>
            </breadcrumb-item>
            <breadcrumb-item >{{$t('INDENT_DOCUMENTS')}}</breadcrumb-item>
          </Breadcrumb>
        </div>
        <div class="header-item f-right" v-if="indentDetails && $hasFeature('indent_details_download')">
          <Button type="primary" @click="downloadIndentDetails">
            {{ $t('INDENT_DETAILS_DOWNLOAD') }}
          </Button>
        </div>
      </div>
    </portal>
    <div>
      <empty-state
        v-if="!indentDetails && !isIndentLoading"
        icon="mdm"
        :text="Messages.ERR_ORDER_NOT_FOUND"/>
      <div class="panel-card card-lg clearfix"
        :class="isDrawerVisible && `slider-open`" v-if="!isIndentLoading">
        <div class="card-left">
          <consignees-detail
            v-for="(consignee,idx) in destinations"
            :key="idx"
            :consigneeIdx="idx"
            :consignee="consignee"
            :destinations="destinationsByConsignee(consignee)"
            :source="currentSource"
            :lrGenerateCategory="getLRGenerateCategory"
            :isDrawerVisible.sync="isDrawerVisible"
            :currentSelectedConsigneeLr.sync="currentSelectedConsigneeLr"
            :selectedConsignee.sync="selectedConsignee"
            :lrAttachmentsLimit="lrAttachmentsLimit"
            :editLr="editLr"
            :materialDetails="consigneeMaterials.materials"
            :isMultiDropGateConfig="isMultiDropGateConfig"
            :uniqueDivisionsList="getUniqueDivisionsList(consignee)"
            :orderDetails="indentDetails"
            :legalEntityDetails="legalEntityDetails"
            :lorryReceipts="lorryReceipts"
            :isMaterialsLoading="isMaterialsLoading"
            :materialsMetaData="getAllMaterialsMetaData"
            :consgtNumberDetailsForConsignee="getConsignmentNumbers(consignee)"
            :isMaterialLREnabled="isMaterialLREnabled"
            :disableUpload.sync="disableUpload"
            :showRemoveDocuments.sync="showRemoveDocuments"
            :allowDelete.sync="allowDelete"
            :podAiDestStatus="getPodAiDestStatus(consignee)"
            @refetchPodStatus="fetchPodAiValidationStatus"
            @openPodAiSlider="openPodAiSlider"
            @saveLr="saveLr"
            @saveMaterialInvoiceLevelLR="saveMaterialInvoiceLevelLR"
            @addAttachments="addAttachments"
            @updateEditLr="updateEditLr"
            @selectConsignee="selectConsignee"
            @openPreviewSlider="openAttachmentPreview"
            @setCurrentAttachments="setDrawerAttachments"/>
        </div>
        <materials-consignee
          v-if="!isMaterialsLoading"
          :slidableColumns="slidableColumns"
          :fixedColumns="fixedColumns"
          :materialDetails="consigneeMaterials"
          :isMaterialsLoading="isMaterialsLoading"
          :orderSummary="indentDetails.material_summary"
          :orderNo="indentDetails.order_no"
          :deliveryType="indentDetails.vehicle_type_data.vehicle_type"
          :movement="indentDetails.movement"
          :orderDetails="indentDetails"
          :consignee="destinations[selectedConsignee]"
          :isEpodVisible="isDispatched"
          :isEpodEditable="isEpodEditable"
          :lrGenerateCategory="getLRGenerateCategory"
          :isMultiDropGateConfig="isMultiDropGateConfig"
          :source="currentSource"
          :unsavedReturnMaterialDetails="unsavedReturnMaterialDetails"
          :configurations="configurations"
          :materialCustomColumn="getMaterialCustomFields"
          ref="material_consignee"
          @update-returned-materials="updateReturnedMaterials"
          @updateGrn="updateGrn"
          @updatePackageByPackageId="updatePackageByPackageId"
          @resetMaterials="resetMaterials"/>
        <div class="card-right mlp-30" v-else>
          <Spinner />
        </div>
      </div>
      <div v-else>
        <Spinner />
      </div>
      <Drawer
        v-if="!isIndentLoading"
        :visible.sync="isDrawerVisible"
        direction="rtl"
        size="640px"
        :modal="false"
        modal-wrapper="false"
        :withHeader="false"
        class="default-drawer dark">
        <Link :underline="false" class="nav-close" @click="isDrawerVisible=false">
          <svgicon name="cancelwhite" width="12" height="12" :original="true" />
        </Link>
        <div class="drawer-body">
          <div class="flex-container align-top">
            <div class="flex-item">
              <p v-for="lr in currentSelectedConsigneeLr"
                :key="lr.lr_number">
                <span class="text-grey-light1">{{lr.title}}:</span>
                <strong class="text-bold">{{lr.lr_number}}</strong>
              </p>
            </div>
          </div>
          <div
            v-if="$hasFeature('pod_rejection_by_ai') && podAiSliderConsignee && getPodAiRejectionReasons(podAiSliderConsignee).length"
            class="pod-ai-validation-box mb-20"
          >
            <div class="pod-ai-validation-header mb-5">
              <svgicon name="icon-info-circle" width="16" height="16" :original="true" />
              <strong class="ml-5">POD Validation</strong>
            </div>
            <p class="text-sm mt-0 mb-10" style="color: #aaa;">This POD failed AI validation. Fix the issues below and upload the document again.</p>
            <div
              v-for="reason in getPodAiRejectionReasons(podAiSliderConsignee)"
              :key="reason.code"
              class="pod-ai-reason-item"
            >
              <svgicon name="icon-warning-circle" width="14" height="14" :original="true" />
              <span class="ml-5">{{ reason.label }}</span>
            </div>
            <div class="pod-ai-retrigger-btn mt-15">
              <Button
                type="primary"
                size="mini"
                @click="retriggerPodValidation(podAiSliderConsignee)"
              >Retrigger</Button>
            </div>
          </div>
          <!-- <AttachmentsPreview
            v-if="currentLrAttachments && isDrawerVisible"
            :attachments="currentLrAttachments"
            :maxAllowed="lrAttachmentsLimit"
            :multiple=true
            @setGA="$emit('setGA', { type: 'Click',event: $event})"
            @addAttachments="addAttachments"
            @removeAttachments="removeAttachments"/> -->
            <Attachments
                :attachments="currentLrAttachments"
                :allowDelete.sync="allowDelete"
                :showPreview="true"
                :showRemoveDocuments.sync="showRemoveDocuments"
                :multiple="true"
                :maxAllowed="lrAttachmentsLimit"
                :disableUpload.sync="disableUpload"
                @addAttachments="addAttachments"
                @removeAttachments="removeAttachments"/>
        </div>
      </Drawer>
    </div>
    <UploadDocumentModal
      v-show="isConsolidatedEnabled"
      :visible="uploadModalVisible"
      :destination="activeDestination || {}"
      :indent-no="(indentDetails && indentDetails.order_no) || ''"
      :movement="movementPermissionSuffix"
      @close="uploadModalVisible = false"
      @uploaded="onAttachmentUploaded"
    />
    <Drawer
      v-if="isConsolidatedEnabled"
      :visible.sync="previewDrawerVisible"
      direction="rtl"
      size="600px"
      :modal="true"
      modal-wrapper="false"
      :append-to-body="true"
      :withHeader="false"
      class="default-drawer dark"
    >
      <Link :underline="false" class="nav-close" @click="previewDrawerVisible = false">
        <svgicon name="cancelwhite" width="12" height="12" :original="true" />
      </Link>
      <div class="drawer-body">
        <AttachmentPreviewDrawer
          v-if="previewDrawerVisible"
          ref="attachmentPreviewDrawer"
          :destinations="destinations"
          :destination-index="activeDestinationIndex"
          :indent-no="(indentDetails && indentDetails.order_no) || ''"
          :movement="movementPermissionSuffix"
          @deleted="onAttachmentDeleted"
          @add-attachment="onDrawerAddAttachment"
        />
      </div>
    </Drawer>
  </div>
</template>
<script>
/* eslint-disable import/no-extraneous-dependencies */
import { mapGetters } from 'vuex';
import { groupBy, uniqBy, cloneDeep, isEmpty } from 'lodash';
import materialColumns from '@/constants/material-columns';
import ConsigneesDetail from '@/modules/indents/components/details/consigneesDetail';
import EmptyState from '@/components/common/EmptyState';
import { Messages } from '@/constants/messages';
import MaterialsConsignee from '@/modules/indents/components/details/materials/materialsConsignee';
import Attachments from '@common/components/Attachments';
import { movementMapLower, movementMapLowerForConfig, InvertedMovements } from 'pando-constants';
import { MessageBox } from 'element-ui';
import UploadDocumentModal from '@/modules/indents/components/UploadDocumentModal';
import AttachmentPreviewDrawer from '@/modules/indents/components/AttachmentPreviewDrawer';
export default {
  components: {
    ConsigneesDetail,
    EmptyState,
    MaterialsConsignee,
    Attachments,
    UploadDocumentModal,
    AttachmentPreviewDrawer,
  },
  data() {
    return {
      isDrawerVisible: false,
      showRemoveDocuments: false,
      disableUpload: false,
      uploadModalVisible: false,
      previewDrawerVisible: false,
      activeDestination: null,
      activeDestinationIndex: 0,
      slidableColumns: materialColumns.slidableColumns,
      indentDetails: null,
      isIndentLoading: true,
      Messages,
      selectedConsignee: 0,
      isMaterialsLoading: true,
      editLr: {},
      currentLrAttachments: [],
      consigneeMaterials: {},
      movementMapLower,
      movementMapLowerForConfig,

      legalEntityDetails: [],

      currentSelectedConsigneeLr: [],
      podAiValidationStatus: null,
      podAiSliderConsignee: null,
    };
  },
  watch: {
    isPostDispatchRestricted: {
      immediate: true,
      handler(val) {
        this.disableUpload = val;
      },
    },
  },
  async created() {
    await this.loadLegalEntity();
    await this.loadIndent();
    await this.selectConsignee(0);
  },
  computed: {
    ...mapGetters({
      configurations: 'app/currentClientConfig',
      filter: 'indents/filter',
      userEdited: 'indents/userEdited',
      warnedOnce: 'indents/warnedOnce',
      transporterBookingData: 'order/trackingList',
      unsavedReturnMaterialDetails: 'indents/returnMaterialDetails',
      returnMaterialsWarnedOnce: 'indents/returnMaterialsWarnedOnce',
    }),
    isConsolidatedEnabled() {
      return this.$hasFeature('transporter_consolidated_attachment_management');
    },
    // Maps numeric movement to permission suffix. Uses 'vendor' for inward (3) — matches permission key naming.
    movementPermissionSuffix() {
      const map = { 1: 'secondary', 2: 'primary', 3: 'vendor', 4: 'return' };
      return map[this.indentDetails && this.indentDetails.movement] || 'primary';
    },
    allowDelete() {
      if (!this.isConsolidatedEnabled) {
        return this.$hasPermission(`transporter_add_elr_attachments_${this.movementPermissionSuffix}`);
      }
      return this.$hasPermission(`transporter_delete_elr_attachments_${this.movementPermissionSuffix}`);
    },
    isReturnMaterialsEnabled() {
      return this.$hasFeature('return_management');
    },
    isPostDispatchRestricted() {
      const movement = this.indentDetails && this.indentDetails.movement;
      const movementSuffix = movement && InvertedMovements[movement];
      const restrictPermission = movementSuffix && `restrict_lr_attachment_post_dispatch_${movementSuffix}`;
      const orderStatus = this.indentDetails && this.indentDetails.status;
      return (this.$statusUtil.isDispatched(orderStatus) || this.$statusUtil.isAfterDispatched(orderStatus))
        && !!restrictPermission && this.$hasPermission(restrictPermission);
    },
    lrAttachmentsLimit() {
      return (this.configurations && this.configurations.attachments_limit &&
        this.configurations.attachments_limit.lr) ? this.configurations.attachments_limit.lr : 5;
    },
    lorryReceipts() {
      return this.indentDetails && this.indentDetails.lorry_receipt;
    },
    isInDeliveryState() {
      return this.indentDetails.status === this.$statusUtil.getStatusId('delivery_pending') ||
        this.indentDetails.status === this.$statusUtil.getStatusId('dispatched');
    },
    isEpodEditable() {
      const movement = this.indentDetails && this.indentDetails.movement;
      if (!movement) {
        return false;
      }
      return this.isInDeliveryState && (
        this.configurations &&
        this.configurations.is_grn_enabled_for_transporter &&
        this.configurations.is_grn_enabled_for_transporter[
          this.movementMapLowerForConfig[movement]
        ]
      );
    },
    getLRGenerateCategory() {
      return (this.indentDetails && this.indentDetails.lr_type) ||
       (this.configurations && this.configurations.lorry_receipt_generate_category);
    },
    getMaterialCustomFields() {
      if (this.indentDetails.material_custom_fields) {
        const indentCustomeFields = Object.keys(this.indentDetails.material_custom_fields).map((keys, index) => ({
          column: keys,
          label: this.indentDetails.material_custom_fields[keys],
          id: index + 1,
          w: '140',
          fixed: false,
        }));
        return indentCustomeFields;
      }
      return [];
    },
    fixedColumns() {
      return materialColumns.fixedColumns.filter((column) => {
        if (column.feature) {
          if (this.$hasFeature(column.feature)) {
            return true;
          }
          return false;
        }
        return column.showAlways || this.attachments;
      });
    },
    lorryReceiptGroup() {
      return groupBy(
        this.indentDetails.lorry_receipt,
        'destination_location_id',
      );
    },
    isDispatched() {
      const orderStatus = this.indentDetails.status;
      return (
        this.$statusUtil.isDispatched(orderStatus) ||
        this.$statusUtil.isAfterDispatched(orderStatus)
      );
    },
    destinationsByLocationId() {
      return groupBy(this.indentDetails.destinations, 'location_id');
    },
    isMultiDropGateConfig() {
      return this.configurations && this.configurations.multi_drop_at_gate_level;
    },
    destinations() {
      if (this.isMultiDropGateConfig && this.indentDetails.destinations) {
        return uniqBy(this.indentDetails.destinations, v => [v.location_id, v.gate_id].join());
      }
      return this.indentDetails.destinations
        && uniqBy(this.indentDetails.destinations, 'location_id');
    },
    getAllMaterialsMetaData() {
      return this.indentDetails.consignee_materials;
    },
    uniqueDivisionsList() {
      return (this.consigneeMaterials && this.consigneeMaterials.divisions) || {};
    },
    routeToIndentPath() {
      return { path: '/indents' };
    },
    routeToHistoricIndentPath() {
      return { path: '/historicIndents' };
    },
    currentSource() {
      const id = this.destinations[this.selectedConsignee].source_location_id;
      return this.indentDetails.sources &&
        this.indentDetails.sources.find(source => source.location_id === id);
    },
    canShowConsignmentNumber() {
      return this.$hasPermission('update_consignment_number') &&
        (this.indentDetails && this.indentDetails.meta.courier) && this.indentDetails.meta.courier.add_manual_consignment_number;
    },
    hideConsignmentEdit() {
      return this.$statusUtil.getStatusIds(['delivered', 'delivery_pending', 'cancelled']).includes(this.indentDetails.status);
    },
    isMaterialLREnabled() {
      return this.configurations && this.configurations.manual_lr;
    },
  },
  methods: {
    toggleVisibility() {
      this.isVisible = !this.isVisible;
    },
    updateReturnedMaterials(returnedMaterials) {
      this.consigneeMaterials.materials = this.consigneeMaterials.materials.map((material) => {
        const modifiedMaterial = material;
        if (returnedMaterials[material.id]) {
          modifiedMaterial.return_count = returnedMaterials[material.id];
        }
        return modifiedMaterial;
      });
      this.consigneeMaterials = { ...this.consigneeMaterials };
      return true;
    },
    getUniqueDivisionsList(consignee) {
      if (this.isMultiDropGateConfig && consignee.gate_id) {
        return this.uniqueDivisionsList[consignee.gate_id];
      }
      return this.uniqueDivisionsList[consignee.location_id];
    },
    destinationsByConsignee(destination) {
      if (this.isMultiDropGateConfig && destination.gate_id) {
        return this.destinationsByLocationId[destination.location_id].filter(val =>
          destination.gate_id === val.gate_id,
        );
      }
      return this.destinationsByLocationId[destination.location_id];
    },
    downloadIndentDetails() {
      const orderNo = this.indentDetails.order_no;
      this.$store.dispatch('indents/downloadIndentDetails', orderNo);
    },
    routeToIndentList() {
      if (this.isReturnMaterialsEnabled && !isEmpty(this.unsavedReturnMaterialDetails) && !this.returnMaterialsWarnedOnce) {
        this.$warningMessage({ message: this.$t('RETURN_MATERIALS_UNSAVED_WARNING') });
        this.$store.commit('indents/setReturnMaterialsWarnedOnce', true);
      } else if (this.userEdited && !this.warnedOnce) {
        this.$warningMessage({ message: this.$getConst('EPOD_VALUE_CHANGED') });
        this.$store.commit('indents/hasWarnedOnce', true);
      } else if (this.indentDetails && this.indentDetails.status !== 7) {
        this.$router.push(this.routeToIndentPath);
      } else {
        this.$router.push(this.routeToHistoricIndentPath);
      }
    },
    async addAttachments(file, consigneeIdx = null, index = null) {
      if (this.isConsolidatedEnabled) {
        this.activeDestination = this.destinations[consigneeIdx ?? this.selectedConsignee];
        this.uploadModalVisible = true;
        return;
      }
      const formData = new FormData();
      const consignee = this.destinations[this.selectedConsignee];
      formData.append('attachment', file.raw);
      const result = await this.$store.dispatch(
        'indents/uploadDocument',
        formData,
      );
      if (result) {
        const lorryReceipts = [
          {
            destination_id: consignee.location_id,
            gate_id: consignee.gate_id,
            source_location_id: consignee.source_location_id,
            lr_attachment_ids: [result.id],
          },
        ];
        const response = await this.$store.dispatch('indents/updateDocument', {
          indentNo: this.indentDetails.order_no,
          lorryReceipts,
        });
        if (response.data) {
          const currentIndentDetails = cloneDeep(this.indentDetails);
          const currentConsignee = (this.destinationsByConsignee(consignee) &&
            this.destinationsByConsignee(consignee)[0]) || {};
          currentConsignee.lr_attachment_ids.push(result.id);
          currentConsignee.lr_details.push(result);
          const currentLr = currentIndentDetails.lorry_receipt.map((lr) => {
            const lrResult = { ...lr };
            if (
              lrResult.destination_location_id === currentConsignee.location_id
            ) {
              lrResult.document_available = true;
            }
            return lrResult;
          });
          currentIndentDetails.destinations[
            this.selectedConsignee
          ] = currentConsignee;
          currentIndentDetails.lorry_receipt = currentLr;
          this.indentDetails = cloneDeep(currentIndentDetails);
          const attachment = {
            name: result.name,
            id: result.id,
            url: result.attachment_url,
            index: index || this.currentLrAttachments.length,
          };
          this.currentLrAttachments = [
            ...this.currentLrAttachments,
            attachment,
          ];
        } else {
          const apiError = (response && response.error) || (response && response.errors && response.errors[0] && response.errors[0].message);
          this.$errorMessage({ message: apiError || this.$getErr('UPLOAD_FAILS') });
        }
      } else {
        this.$errorMessage({ message: this.$getErr('UPLOAD_FAILS') });
      }
    },
    async removeAttachments(file) {
      if (this.isConsolidatedEnabled) {
        const documentType = file.documentType || 'lr';
        await this.$store.dispatch('indents/deleteV1Attachment', {
          indentNo: this.indentDetails.order_no,
          attachmentId: file.id,
          // eslint-disable-next-line no-underscore-dangle
          destinationId: this.destinations[this.selectedConsignee]._id,
          documentType,
        });
        await this.refreshAttachments();
        return;
      }
      const data = {
        indentNo: this.indentDetails.order_no,
        consigneeNo: this.destinations[this.selectedConsignee].location_id,
        file_id: file.id,
      };
      const response = await this.$store.dispatch('indents/removeAttachment', { data });
      if (response && response.error) {
        this.$errorMessage({ message: response.error });
        return;
      }
      const currentIndentDetails = cloneDeep(this.indentDetails);
      const currentConsignee = currentIndentDetails.destinations[this.selectedConsignee];
      currentConsignee.lr_attachment_ids.splice(
        currentConsignee.lr_attachment_ids.indexOf(file.id),
        1,
      );
      currentConsignee.lr_details = currentConsignee.lr_details.filter(lr => lr.id !== file.id);
      currentIndentDetails.destinations[this.selectedConsignee] = currentConsignee;
      if (!currentConsignee.lr_attachment_ids.length) {
        const currentLr = currentIndentDetails.lorry_receipt.map((lr) => {
          const lrResult = { ...lr };
          if (
            lrResult.destination_location_id === currentConsignee.location_id
          ) {
            lrResult.document_available = false;
          }
          return lrResult;
        });
        currentIndentDetails.lorry_receipt = currentLr;
      }
      this.indentDetails = cloneDeep(currentIndentDetails);
      this.currentLrAttachments = this.currentLrAttachments.filter(
        attachment => attachment.id !== file.id,
      );

      this.currentLrAttachments.forEach((attachment, index) => {
        // eslint-disable-next-line no-param-reassign
        attachment.index = index;
      });
    },
    async updateGrn({ consigneeNo, data }) {
      //
      const indentNo = this.indentDetails.order_no;
      const result = await this.$store.dispatch('indents/updateGrn', {
        indentNo,
        consigneeNo,
        data,
      });
      if (result.error) {
        this.$errorMessage({ message: result.error });
      } else {
        await this.updateConsigneeMaterials(data.materials);
        let successMessage = `${this.$getSuccess('GRN_SAVE_SUCCESS')} ${this.getTotalEpod()}`;
        if (result.data) {
          if (result.data.epodSentForApproval) {
            successMessage = `${this.$getSuccess('GRN_SENT_FOR_APPROVAL')}. ${this.getTotalEpod()}`;
          } else if (result.data.epodAutoApproved) {
            successMessage = `${this.$getSuccess('GRN_AUTO_APPROVED')}. ${this.getTotalEpod()}`;
          }
        }
        this.$successMessage({ message: successMessage });
        this.$refs.material_consignee.clearReturnMaterialDetails();
        await this.loadIndent();
      }
    },
    getTotalEpod() {
      const result = {
        shortage: 0,
        damage: 0,
      };
      if (this.consigneeMaterials && this.consigneeMaterials.materials) {
        this.consigneeMaterials.materials.forEach((material) => {
          result.shortage += material.epod.shortage_count;
          result.damage += material.epod.damage_count;
        });
      }
      return `Total shortage: ${result.shortage || 0} Total damage: ${result.damage || 0}`;
    },
    updateConsigneeMaterials(materialsList) {
      materialsList.forEach((material) => {
        const materialIndex = this.consigneeMaterials.materials
          .findIndex(val => val.id === material.id);
        this.consigneeMaterials.materials[materialIndex].epod = Object
          .assign({}, this.consigneeMaterials.materials[materialIndex].epod, material);
      });
      this.consigneeMaterials = { ...this.consigneeMaterials };
      return true;
    },
    updatePackageByPackageId(packageId, key) {
      this.consigneeMaterials.materials.forEach((material, materialIndex) => {
        if (material.packages && material.packages.length &&
          material.packages.some(val => val.id === packageId)) {
          if (key === 'is_package_shortage') {
            this.consigneeMaterials.materials[materialIndex].epod.shortage_count =
              this.consigneeMaterials.materials[materialIndex].quantity.value;
            this.consigneeMaterials.materials[materialIndex].epod.damage_count = 0;
            this.consigneeMaterials.packages[packageId].is_package_damaged = false;
            this.consigneeMaterials.packages[packageId].is_package_shortage = true;
          }
          if (key === 'is_package_damaged') {
            this.consigneeMaterials.materials[materialIndex].epod.damage_count =
              this.consigneeMaterials.materials[materialIndex].quantity.value;
            this.consigneeMaterials.materials[materialIndex].epod.shortage_count = 0;
            this.consigneeMaterials.packages[packageId].is_package_shortage = false;
            this.consigneeMaterials.packages[packageId].is_package_damaged = true;
          }
        }
      });
      this.consigneeMaterials = { ...this.consigneeMaterials };
    },
    resetMaterials(packageId, key) {
      if (key === 'is_package_damaged') {
        this.consigneeMaterials.materials.forEach((material, materialIndex) => {
          if (material.packages && material.packages.length &&
          material.packages.some(val => val.id === packageId)) {
            this.consigneeMaterials.materials[materialIndex].epod.damage_count = 0;
          }
        });
      }
      if (key === 'is_package_shortage') {
        this.consigneeMaterials.materials.forEach((material, materialIndex) => {
          if (material.packages && material.packages.length &&
          material.packages.some(val => val.id === packageId)) {
            this.consigneeMaterials.materials[materialIndex].epod.shortage_count = 0;
          }
        });
      }
      this.consigneeMaterials.packages[packageId].is_package_shortage = false;
      this.consigneeMaterials.packages[packageId].is_package_damaged = false;
      this.consigneeMaterials = { ...this.consigneeMaterials };
    },
    async refreshAttachments() {
      await this.$store.dispatch('indents/getLrAttachments', { orderId: this.indentDetails.order_no });
      await this.refreshV2AttachmentsCount();
    },
    async refreshV2AttachmentsCount() {
      if (!this.isConsolidatedEnabled) return;
      const response = await this.$store.dispatch('indents/listV2Attachments', {
        indentNo: this.indentDetails.order_no,
      });
      const list = Array.isArray(response) ? response : (response && response.data) || [];
      list.forEach((destData) => {
        const destIndex = this.indentDetails.destinations.findIndex(
          d => (d.gate_id || d.location_id) && (d.gate_id || d.location_id).toString() === destData.destination_id,
        );
        if (destIndex === -1) return;
        const allFiles = [
          ...(destData.lr_attachments || []),
          ...(destData.pod_attachments || []),
          ...(destData.other_attachments || []),
        ];
        const mapped = allFiles.map(a => ({
          // eslint-disable-next-line no-underscore-dangle
          id: a._id,
          name: a.content_file_name,
          attachment_url: a.metadata && a.metadata.location,
        }));
        this.$set(this.indentDetails.destinations[destIndex], 'lr_details', mapped);
        // Replace the destination object with a new reference so Vue propagates the change to consigneesDetail consignee prop
        this.indentDetails.destinations.splice(destIndex, 1, { ...this.indentDetails.destinations[destIndex] });
      });
      this.indentDetails = { ...this.indentDetails };
    },
    async onAttachmentUploaded() {
      this.uploadModalVisible = false;
      await this.refreshAttachments();
      if (this.$refs.attachmentPreviewDrawer) {
        await this.$refs.attachmentPreviewDrawer.fetchAttachments();
      }
    },
    openAttachmentPreview(consigneeIdx = null) {
      const idx = consigneeIdx ?? this.selectedConsignee;
      this.activeDestination = this.destinations[idx];
      this.activeDestinationIndex = idx;
      this.previewDrawerVisible = true;
    },
    onDrawerAddAttachment(destinationIndex) {
      this.activeDestination = this.destinations[destinationIndex];
      this.uploadModalVisible = true;
    },
    async onAttachmentDeleted() {
      this.previewDrawerVisible = false;
      await this.refreshAttachments();
    },
    async selectConsignee(consigneeIdx) {
      if (this.isReturnMaterialsEnabled && consigneeIdx !== this.selectedConsignee &&
        !isEmpty(this.unsavedReturnMaterialDetails) && !this.returnMaterialsWarnedOnce) {
        this.$warningMessage({ message: this.$t('RETURN_MATERIALS_UNSAVED_WARNING') });
        this.$store.commit('indents/setReturnMaterialsWarnedOnce', true);
      } else if (this.userEdited && !this.warnedOnce && (consigneeIdx !== this.selectedConsignee)) {
        this.$warningMessage({ message: this.$getConst('EPOD_VALUE_CHANGED') });
        this.$store.commit('indents/hasWarnedOnce', true);
      } else {
        if (this.$refs.material_consignee) {
          this.$refs.material_consignee.clearReturnMaterialDetails();
        }
        this.selectedConsignee = consigneeIdx;
        this.editLr = {};
        this.$store.commit('indents/setCanShowSaveGRN', true);
        await this.loadMaterials();
      }
    },
    async loadLegalEntity() {
      try {
        const result = await this.$store.dispatch('indents/getLegalEntity', {
          orderNo: this.$route.params.orderNo,
        });
        if (!result || result.error) {
          this.$errorMessage({ message: 'Cannot load legal entity' });
        } else {
          this.legalEntityDetails = result;
        }
      } catch (err) {
        this.$errorMessage({ message: this.$getErr('APP_CATCH_ERR') });
      }
    },
    async updateEditLr(editLr) {
      this.editLr = { ...editLr };
      Object.keys(editLr).forEach(division =>
        this.$set(this.editLr, division, editLr[division]),
      );
    },
    async loadMaterials() {
      this.isMaterialsLoading = true;
      const indentNo = this.indentDetails.order_no;
      const consigneeNo = this.destinations[this.selectedConsignee].location_id;
      const consigneeMaterialsResult = await this.$store.dispatch('indents/getConsigneeMaterials', {
        indentNo,
        consigneeNo,
      });
      if (consigneeMaterialsResult && consigneeMaterialsResult.error) {
        this.$errorMessage({ message: consigneeMaterialsResult.error });
      } else if (!consigneeMaterialsResult || !consigneeMaterialsResult.data) {
        this.$errorMessage({ message: this.$getErr('GENERAL_ERR') });
      } else {
        this.consigneeMaterials = consigneeMaterialsResult.data;
      }
      this.isMaterialsLoading = false;
    },
    async saveLr({ data, division }) {
      try {
        if (this.$hasFeature('restrict_comma_in_lr') && data && data.some(lr => lr.lr_number && lr.lr_number.includes(','))) {
          this.$errorMessage({ message: 'Only single LR number allowed per field' });
          return null;
        }
        const orderNo = this.indentDetails.order_no;
        const result = await this.$store.dispatch('indents/updateLR', {
          orderNo,
          data,
        });
        if (result.data) {
          this.$successMessage({ message: this.$t('INDENT_LR_NUMBER_TOAST_MSG') });
          this.$set(this.editLr, `${division}`, null);
          if (data && data.length && this.canShowConsignmentNumber && !this.hideConsignmentEdit) {
            await this.saveConsignmentNumber(data[0]);
          }
        } else if (!result || result.error) {
          if (result && result.error && result.error.includes('LR Number')) {
            this.$errorMessage({ message: result.error.split(' - Validation  error')[0] });
          } else if (result && result.error && result.error.includes('Only single LR number allowed')) {
            this.$errorMessage({ message: 'Only single LR number allowed per field' });
          } else {
            this.$errorMessage({
              message: 'LR number save failed. Please try after some time!',
            });
          }
        }
        return result;
      } catch (error) {
        this.$errorMessage({ message: this.$getErr('GENERAL_ERR') });
        return error;
      }
    },
    async saveMaterialInvoiceLevelLR({ data }) {
      try {
        if (this.$hasFeature('restrict_comma_in_lr') && data && data.some(lr => lr.lr_number && lr.lr_number.includes(','))) {
          this.$errorMessage({ message: 'Only single LR number allowed per field' });
          return null;
        }
        const orderId = this.indentDetails.order_no;
        const result = await this.$store.dispatch('indents/updateMaterialInvoiceLR', {
          orderId,
          data,
        });
        if (result && !result.error) {
          this.$successMessage({ message: 'Material Invoice LR Number Saved' });
          await this.loadIndent();
          // this.$set(this.editLr, `${division}`, null);
        } else if (!result || result.error) {
          if (result && result.error && result.error.includes('LR Number')) {
            this.$errorMessage({ message: result.error.split(' - Validation  error')[0] });
          } else if (result && result.error && result.error.includes('Only single LR number allowed')) {
            this.$errorMessage({ message: 'Only single LR number allowed per field' });
          } else {
            this.$errorMessage({
              message: 'Material Invoice LR number save failed. Please try after some time!',
            });
          }
        }
        return result;
      } catch (error) {
        this.$errorMessage({ message: this.$getErr('GENERAL_ERR') });
        return error;
      }
    },
    async saveConsignmentNumber(lrData) {
      try {
        this.isLoading = true;
        if (!isEmpty(lrData.lr_number)) {
          const orderId = this.indentDetails.order_no;
          const transporterName = this.indentDetails && this.indentDetails.transporter && this.indentDetails.transporter.name;
          let consigneeId = this.destinations[this.selectedConsignee].location_id;
          if (this.isMultiDropGateConfig) {
            consigneeId = this.destinations[this.selectedConsignee].gate_id ||
              this.destinations[this.selectedConsignee].location_id;
          }
          const data = {
            consignment_number: lrData.lr_number,
            ...lrData,
          };
          setInterval(() => {
            if (this.isLoading) {
              this.$warningMessage({ message: this.$getConst('COURIER_WARNING', { firstArgument: transporterName }) });
            }
          }, 10000);
          const result = await this.$store.dispatch('indents/updateConsignmentNumber', {
            orderId,
            consigneeId,
            data,
          });
          if (!result) {
            this.$error({ message: this.$getErr('CONSIGNMENT_UPDATE_FAILURE') });
          } else if (result.error) {
            if (result.error === 'Consignment not found') {
              this.$error({ message: this.$getErr('CONSIGNMENT_UPDATE_INVALID') });
            } else {
              this.$error({ message: await this.$getErr('TIMEOUT', { firstArgument: transporterName }) });
            }
          } else {
            this.isConsignmentEdit = false;
            await this.getTransporterBooking();
            this.$success({ message: this.$getSuccess('CONSIGNMENT_UPDATE_SUCCESS') });
          }
        } else {
          this.$error({ message: this.$getErr('CONSIGNMENT_UPDATE_EMPTY') });
        }
      } catch (error) {
        this.$error({ message: this.$getErr('CONSIGNMENT_UPDATE_FAILURE') });
      } finally {
        this.isLoading = false;
      }
    },
    setDrawerAttachments(lrAttachments) {
      this.podAiSliderConsignee = null;
      this.currentLrAttachments = lrAttachments;
    },
    async loadIndent() {
      this.isIndentLoading = true;
      const indentDetailsResult = await this.$store.dispatch(
        'indents/getIndentDetails',
        this.$route.params,
      );
      const lrDetailsResult = await this.$store.dispatch(
        'indents/getLrAttachments',
        { orderId: this.$route.params.orderNo },
      );
      if (indentDetailsResult && indentDetailsResult.error) {
        this.$errorMessage({ message: indentDetailsResult.error });
      } else if (lrDetailsResult && lrDetailsResult.error) {
        this.$errorMessage({ message: lrDetailsResult.error });
      } else if (
        !(
          lrDetailsResult &&
          lrDetailsResult.data &&
          indentDetailsResult &&
          indentDetailsResult.data
        )
      ) {
        this.$errorMessage({ message: this.$getErr('GENERAL_ERR') });
      } else {
        this.indentDetails = indentDetailsResult.data;
        const lrDetails = lrDetailsResult.data;
        this.indentDetails.destinations = this.indentDetails.destinations.map(
          (destination) => {
            const consignee = destination;
            let currentLr = {};
            if (this.isMultiDropGateConfig && consignee.gate_id) {
              currentLr = lrDetails.consignees.find(
                lrConsignee => consignee.location_id === lrConsignee.id &&
                consignee.gate_id === lrConsignee.gate_id,
              );
            } else {
              currentLr = lrDetails.consignees.find(
                lrConsignee => consignee.location_id === lrConsignee.id,
              );
            }
            if (currentLr) {
              consignee.lr_details = currentLr.lr_details || [];
            }
            return consignee;
          },
        );
        await this.getTransporterBooking();
        if (this.$hasFeature('pod_rejection_by_ai')) {
          this.fetchPodAiValidationStatus();
        }
      }
      this.isIndentLoading = false;
      await this.refreshV2AttachmentsCount();
    },
    async fetchPodAiValidationStatus() {
      try {
        const result = await this.$store.dispatch('podAiValidation/fetchStatus', {
          orderNo: this.$route.params.orderNo,
        });
        this.podAiValidationStatus = result;
      } catch (err) {
        // silent fail
      }
    },
    getPodAiDestStatus(consignee) {
      if (!this.podAiValidationStatus || !this.podAiValidationStatus.destinations) return null;
      const locId = consignee.location_id && consignee.location_id.toString();
      const found = this.podAiValidationStatus.destinations.find(
        d => d.destination_id && d.destination_id.toString() === locId,
      );
      return found ? found.status : null;
    },
    getPodAiRejectionReasons(consignee) {
      if (!this.podAiValidationStatus || !this.podAiValidationStatus.destinations) return [];
      const locId = consignee.location_id && consignee.location_id.toString();
      const found = this.podAiValidationStatus.destinations.find(
        d => d.destination_id && d.destination_id.toString() === locId,
      );
      return (found && found.rejection_reasons) || [];
    },
    openPodAiSlider(consignee) {
      this.podAiSliderConsignee = consignee;
    },
    async retriggerPodValidation(consignee) {
      try {
        const destinationName = consignee.address && consignee.address.name;
        await MessageBox.confirm(
          this.$t('POD_AI_RETRIGGER_CONFIRM_MSG', { destName: destinationName }),
          this.$t('POD_AI_RETRIGGER_TITLE'),
          {
            confirmButtonText: 'Retrigger',
            cancelButtonText: 'Cancel',
            customClass: 'pod-ai-retrigger-confirm',
            appendToBody: true,
          },
        );
        const orderNo = this.indentDetails.order_no;
        const destinationId = consignee.location_id;
        await this.$store.dispatch('podAiValidation/resubmit', { orderNo, destinationId });
        this.$successMessage({ message: this.$t('POD_AI_RETRIGGER_SUCCESS') });
      } catch (err) {
        if (err !== 'cancel') {
          this.$errorMessage({ message: err?.data?.error || 'Failed to resubmit POD validation' });
        }
      }
    },
    getConsignmentNumbers(destination) {
      if (this.transporterBookingData && this.transporterBookingData.transporterBookings) {
        const destinationList = this.indentDetails.destinations
          .filter((dest) => {
            if (this.isMultiDropGateConfig) {
              if (dest.gate_id && destination.gate_id && dest.gate_id.toString() &&
               destination.gate_id.toString()) {
                return dest.gate_id.toString() === destination.gate_id.toString();
              }
            }
            return dest.location_id.toString() === destination.location_id.toString();
          })
          .map(dest => (dest.gate_id && dest.gate_id.toString()) ||
           (dest.location_id && dest.location_id.toString()));
        destinationList.push(destination.location_id.toString());
        const consignmentDetails = this.transporterBookingData.transporterBookings.filter(data =>
          destinationList.includes(data.consignee_id.toString()));
        return consignmentDetails;
      }
      return [];
    },
    async getTransporterBooking() {
      const result = await this.$store.dispatch('order/trackingList', { id: this.indentDetails.order_no });
    },
  },
};
</script>
<style scoped lang="scss">
.mlp-30 {
  margin-left: 30%;
}
.pod-ai-validation-box {
  background-color: #2c2c2c;
  border: 1px solid #444;
  border-radius: 8px;
  padding: 20px 22px;
  color: #fff;

  .pod-ai-validation-header {
    display: flex;
    align-items: center;
    font-size: 1.5rem;
    margin-bottom: 10px;
  }

  .pod-ai-reason-item {
    display: flex;
    align-items: center;
    font-size: 1.3rem;
    margin-top: 10px;
    color: #ff6b6b;
  }
  .pod-ai-retrigger-btn {
    text-align: right;
  }
}
</style>
